import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import alert from '#utilities/js/ea/alert.js'
import confirm from '#utilities/js/ea/confirm.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements as elementsXfiles } from '#components/generics/js/xfiles/styles.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault,
    stopImmediatePropagation,
  ]),
  task: async (
    button
  ) => {
    const form = closest('form', button)
    const { dataset, name } = button
    const { alert: msgAlert, confirm: msgConfirm, scopeJson } = dataset
    const json = JSON.parse(scopeJson)
    const hdn = one('[type="hidden"][name="msg_attach_links"]', form)
    const { value } = hdn
    const buttons = all(`[name='${name}']`, form)
    let result = true

    if (msgConfirm) {
      const { title, text = '' } = JSON.parse(msgConfirm)
      result = await confirm(title, text)
    }

    if (result) {
      if (value && Number(value) === 1) {
        if (json && json.quota) {
          let available = json.quota

          const pj = all(`.${elementsXfiles.xfiles_item}`, form)

          for (const { dataset } of pj) {
            const { size } = dataset

            available = available - size
          }

          if (available <= 0) {
            if (msgAlert) {
              await alert(msgAlert)
            }

            button.setAttribute('aria-checked', 'true')
            button.value = 'on'
          } else {
            for (const btn of buttons) {
              if (btn !== button) {
                btn.setAttribute('aria-checked', 'false')
                btn.value = 'off'
              }
            }
            hdn.value = 0
          }
        } else {
          for (const btn of buttons) {
            if (btn !== button) {
              btn.setAttribute('aria-checked', 'false')
              btn.value = 'off'
            }
          }
          hdn.value = 0
        }
      } else {
        for (const btn of buttons) {
          if (btn !== button) {
            btn.setAttribute('aria-checked', 'true')
            btn.value = 'on'
          }
        }
        hdn.value = 1
      }
    } else {
      if (value && Number(value) === 1) {
        for (const btn of buttons) {
          btn.setAttribute('aria-checked', 'true')
          btn.value = 'on'
        }

        hdn.value = 1
      } else {
        for (const btn of buttons) {
          btn.setAttribute('aria-checked', 'false')
          btn.value = 'off'
        }
        hdn.value = 0
      }
    }
  }
})

export default (
  button
) => {
  onClick.listen(button)
}
